import React from "react";

import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/NavComp/navbar";
import Footer from "./Components/FooterComp/footer";
import Body from "./Components/BodyComp/body";
import WhatsAppButton from "./Components/Whatsapp/WhatsAppButton";
import ContactUs from "./Components/ContactComp/contactus";
import AboutUs from "./Components/AboutComp/aboutus";
import Gallery from "./Components/GalleryComp/gallery";
import Booking from "./Components/BookingComp/booking";
import Services from "./Components/ServicesComp/services";
import Location from "./Components/LocationComp/location";

import ScrollToTop from './ScrollComp/ScrollToTop';

function App() {
  return (
    <>

      <Navbar />
    <ScrollToTop />

    
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/booking" element={< Booking />} />
        <Route path="/services" element={<Services />} />
        <Route path="/location" element={<Location />} />
      </Routes>
      <Footer />

      <WhatsAppButton />
    </>
  );
}

export default App;

